import React from 'react';
import { WeaFormItem, WeaTableEditable,WeaSearchGroup,
    WeaHelpfulTip, WeaInput, WeaSelect, WeaCheckbox, WeaColorPicker  } from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EType from './base/EType';
import ETitle from './base/ETitle';
import ELinkMode from './base/ELinkMode';
import EPortalBrowser from './base/EPortalBrowser';
import DataSourceTable from './base/DataSourceTable';
import { Button, Modal, Row, Col } from "antd";
import {WeaMaterialLib} from 'weaPortalPublic';

// 快捷入口元素
export default class Content_QuickEntry extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datas: this.props.datas || [],
            eShowMode: this.props.showMode || '1',
            eShowNum: this.props.eShowNum || '5',
            eLayout: this.props.eLayout || '0',
            eTitleColor: this.props.eTitleColor || '#000',
        }
        this.getColumns = this.getColumns.bind(this);
        this.getRowSelection = this.getRowSelection.bind(this);
    }

    getRowSelection(rowSelection){
        const { userid='' } = this.props;
        const sel = { ...rowSelection };
        sel.getCheckboxProps = record => {
            return { disabled: userid != '1' && record.userid === "1"};
        };
        return sel;
    };

    getColumns(){
        const { userid='' } = this.props;
        return [
            {
                title: getLabel(24986,'标题') ,
                rowSpan: 2,
                width: "20%",
                dataIndex: "title",
                com: [{
                    type: 'CUSTOM',
                    key: "title",
                    render: (text, record, index) => {
                        let _datas = this.state.datas;
                        let viewAttr = '3';
                        if(userid != '1' && record.userid == '1'){
                            viewAttr = '1';
                        }
                        return <div className="wea-url">
                            <div className="wea-url-toolbarmore-upload">
                                <WeaInput
                                    value={record.title}
                                    viewAttr={viewAttr}
                                    hasBorder
                                    onChange={(value)=>{
                                        _datas[index].title = value
                                        this.setState({
                                            datas: _datas
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    }
                }]
            },{
                title: getLabel(74,'图片'),
                rowSpan: 2,
                dataIndex: "picture",
                width: "22%",
                com: [
                    {
                        key: 'picture',
                        type: 'CUSTOM',
                        viewAttr: '3',
                        defaultValue: '',
                        render: (text, record, index) => {
                            let _datas = this.state.datas;
                            let disabled = false;
                            if(userid != '1' && record.userid == '1'){
                                disabled = true;
                            }
                            return <div className="wea-url">
                                <div className="wea-url-toolbarmore-upload">
                                    <WeaMaterialLib
                                        multiCheck={false}
                                        disabled={disabled}
                                        value={record.picture}
                                        isShow={true}
                                        onChange={(value)=>{
                                            _datas[index].picture = value
                                            this.setState({
                                                datas: _datas
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        }
                    }
                ]
            },
            {
                title: getLabel(16208,'链接地址') ,
                rowSpan: 2,
                width: "20%",
                dataIndex: "link",
                com: [{
                    type: "CUSTOM",
                    key: "link",
                    defaultValue: '',
                    render: (text, record, index) => {
                        let _datas = this.state.datas;
                        let viewAttr = '2';
                        if(userid != '1' && record.userid == '1'){
                            viewAttr = '1';
                        }
                        return <div className="wea-url">
                            <div className="wea-url-toolbarmore-upload">
                                <WeaInput
                                    value={record.link}
                                    hasBorder
                                    viewAttr={viewAttr}
                                    onChange={(value)=>{
                                        _datas[index].link = value
                                        this.setState({
                                            datas: _datas
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    }
                }]
            },
            {
                title: getLabel(128719,'显示顺序') ,
                rowSpan: 2,
                width: "20%",
                dataIndex: "ordernum",
                com: [{
                    type: "CUSTOM",
                    key: "ordernum",
                    defaultValue: 0,
                    render: (text, record, index) => {
                        let _datas = this.state.datas;
                        let viewAttr = '2';
                        if(userid != '1' && record.userid == '1'){
                            viewAttr = '1';
                        }
                        return <div className="wea-url">
                            <div className="wea-url-toolbarmore-upload">
                                <WeaInput
                                    value={record.ordernum}
                                    viewAttr={viewAttr}
                                    hasBorder
                                    onChange={(value)=>{
                                        _datas[index].ordernum = value
                                        this.setState({
                                            datas: _datas
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    }}]
            },
            {
                title: getLabel(15603,'是否显示') ,
                rowSpan: 2,
                width: "15%",
                dataIndex: "ordernum",
                com: [
                    {
                        key: 'isShow',
                        type: 'CUSTOM',
                        viewAttr: '3',
                        defaultValue: '1',
                        render: (text, record, index) => {
                            let disabled = false;
                            if(record.userid != '1' || userid=='1'){
                                disabled = true;
                                record.isShow = '1';
                            }
                            let _datas = this.state.datas;
                            return <div className="wea-url">
                                <div className="wea-url-toolbarmore-upload">
                                    <WeaCheckbox
                                        value={record.isShow}
                                        disabled={disabled}
                                        onChange={(value)=>{
                                            _datas[index].isShow = value
                                            this.setState({
                                                datas: _datas
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        }
                    }
                ]
            }
        ];
    }

    render() {
        const { datas, eShowMode, eShowNum, eTitleColor, eLayout } = this.state;
        const {hpid, eid, ebaseid, eShareLevel, synergyParams, userid} = this.props;

        let __DataSourceTable = <DataSourceTable ref="dataSourceTable" hpid={hpid} eid={eid} ebaseid={ebaseid} {...this.props.eTabs} synergyParams={synergyParams} tabList={datas} userid={userid}/>;

        const itemData = [
            {
                id: "0",
                name: getLabel(515771,'上下布局-无背景色/分割线') ,
                filepath: "/spa/portal/images/quickentry/showmoude0.png",

            },{
                id: "1",
                name: getLabel(515772,'上下布局-有分割线') ,
                filepath: "/spa/portal/images/quickentry/showmoude1.png",
            },{
                id: "2",
                name: getLabel(515773,'上下布局-有背景色') ,
                filepath: "/spa/portal/images/quickentry/showmoude2.png",
            },{
                id: "3",
                name: getLabel(515774,'左右布局-无背景色/分割线') ,
                filepath: "/spa/portal/images/quickentry/showmoude3.png",
            },{
                id: "4",
                name: getLabel(515775,'左右布局-有分割线') ,
                filepath: "/spa/portal/images/quickentry/showmoude4.png",
            },{
                id: "5",
                name: getLabel(515776,'左右布局-有背景色') ,
                filepath: "/spa/portal/images/quickentry/showmoude5.png",
            }
        ];
        let EPerNum = <div></div>;
        let ELayout = <div></div>;
        let EShowType = <div></div>;
        let ETitleColor = <div></div>;

        ELayout = (
            <WeaFormItem label={getLabel(19407,'布局') } labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <WeaSelect value={eLayout} options={[
                    {key: '0',showname: getLabel(515777,'靠左对齐') , selected: true},
                    {key: '1', showname: getLabel(128965,'居中对齐') }
                ]} detailtype = {3} onChange={value => this.setState({eLayout: value})}/>
            </WeaFormItem>
        );
        EPerNum = (
            <WeaFormItem label={getLabel(515778,'每行显示数量') } labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <WeaInput value={eShowNum} style={{width: '100px'}} onChange={value => this.setState({eShowNum: value})}/>
                <WeaHelpfulTip style={{marginLeft: '10px',
                    marginBottom: '5px', display: 'inline-block'}} title={getLabel(515779,'为0时,根据元素宽度自动换行') }/>
            </WeaFormItem>
        );
        EShowType = (
            <WeaFormItem label={getLabel(23724,'显示样式') } labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <EPortalBrowser
                    itemData={itemData}
                    title={getLabel(515780,'选择元素样式') }
                    multiCheck={false}
                    disabled={false}
                    value={eShowMode}
                    isShow={true}
                    onChange={(value)=>{
                        this.setState({eShowMode: value})
                    }}
                />
            </WeaFormItem>
        );

        ETitleColor = (
            <WeaFormItem label={getLabel(2076,'字体颜色') } labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <WeaColorPicker
                    value={eTitleColor}
                    onChange={(v)=> this.setState({eTitleColor: v})}
                />
            </WeaFormItem>
        );

        return (
            <div>
                <WeaSearchGroup title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true}>
                    <EType ref="eType" value={this.props.eBaseName}/>
                    {this.props.eShareLevel == '2' ? <ETitle ref="eTitle" eid={this.props.eid} value={this.props.eTitle}/> : ''}
                    {this.props.eShareLevel == '2' ? EShowType : ''}
                    {EPerNum}
                    {ELayout}
                    {ETitleColor}
                    <ELinkMode ref="eLinkMode" options={this.props.eLinkMode.options} value={this.props.eLinkMode.selected != '1' ? '2' :this.props.eLinkMode.selected }/>
                </WeaSearchGroup>
                {__DataSourceTable}
            </div>
        );
    }

    getSaveValues() {
        const datas = this.state.datas.map((item, index) => {
            item.orderNum = index;
            item.data.orderNum = index;
            return item;
        })
        if(this.table && !this.table.doValidate().pass) return;
        return {
            eContentTitle: this.refs['eTitle'] ? this.refs['eTitle'].getSaveValues() : this.props.eTitle,
            eContentLinkMode: this.refs['eLinkMode'].getSaveValues(),
            eContentShowMode: this.state.eShowMode,
            eContentTitleColor: this.state.eTitleColor,
            eContentLayout: this.state.eLayout,
            eContentShowNum: this.state.eShowNum,
            eContentDatas: datas
        };
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_QuickEntry.js